import React, { useEffect, useState } from "react";
import { putData } from '../../../../services/library';
import { Typography, Grid, Box, Card, TextField,  CardContent, Dialog,  DialogTitle, Button } from "@mui/material";
import moment from "moment";
import { logEventos } from "../../../../services/services";
import Notify from "../../../Notify";

export default function Editar_precios(props) {
    const { datosExisten, open, } = props;
    const [datosForm, setdatosForm] = useState(datosExisten);

    const style = {
        backgroundColor: "#ffffff",
        width: "100%",
    };

    const [datoslista, setDatoslista] = useState({});

    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });

    const almacenar = (event) => {
        const { name, value } = event.target;
        let newValue = { ...datosForm, [name]: value };

        // Reemplazar coma por punto para que parseFloat funcione
        const valorNormalizado = value.replace(',', '.');
        const floatValue = parseFloat(valorNormalizado);

        if (isNaN(floatValue)) {
            setDatoslista(newValue);
            return;
        }

        const densidad = datosExisten.id_empresa === 1
            ? datosExisten.densidad_hipergas
            : datosExisten.densidad_autogas;

        const truncar = (num) => {
            return Number(num).toFixed(2).replace('.', ',');
        };

        if (value === "") {
            setdatosForm({
                ...datoslista,
                precio_litro_sin_iva: "",
                precio_litro_con_iva: "",
                precio_kilo_sin_iva: "",
                precio_kilo_con_iva: "",
                [name]: "",
            });
            return;
        }

        if (name === "precio_litro_sin_iva") {
            const conIva = floatValue * datosForm.valor;
            const kiloConIva = conIva / densidad;
            const kiloSinIva = kiloConIva / datosForm.valor;

            newValue.precio_litro_con_iva = truncar(conIva);
            newValue.precio_kilo_con_iva = truncar(kiloConIva);
            newValue.precio_kilo_sin_iva = truncar(kiloSinIva);
        }

        if (name === "precio_kilo_sin_iva") {
            const conIva = floatValue * datosForm.valor;
            const litroConIva = conIva * densidad;
            const litroSinIva = litroConIva / datosForm.valor;

            newValue.precio_kilo_con_iva = truncar(conIva);
            newValue.precio_litro_con_iva = truncar(litroConIva);
            newValue.precio_litro_sin_iva = truncar(litroSinIva);
        }

        if (name === "precio_litro_con_iva") {
            const sinIva = floatValue / datosForm.valor;
            const kiloSinIva = sinIva / densidad;
            const kiloConIva = kiloSinIva * datosForm.valor;

            newValue.precio_litro_sin_iva = truncar(sinIva);
            newValue.precio_kilo_sin_iva = truncar(kiloSinIva);
            newValue.precio_kilo_con_iva = truncar(kiloConIva);
        }

        if (name === "precio_kilo_con_iva") {
            const sinIva = floatValue / datosForm.valor;
            const litroConIva = sinIva * densidad;
            const litroSinIva = litroConIva / datosForm.valor;

            newValue.precio_kilo_sin_iva = truncar(sinIva);
            newValue.precio_litro_con_iva = truncar(litroConIva);
            newValue.precio_litro_sin_iva = truncar(litroSinIva);
        }

        setdatosForm(newValue);
    };

    //ESTA FUNCION ES PARA GUARDAR, DEBERIA MODIFICARLA MAS ADELATE PARA HACER UNA TRANSACCION
    const putPrecios = async (e) => {
        putData(e, `/lista_precios/${datosExisten.id_lista}`,
            {

                precio_litro_con_iva: datosForm.precio_litro_con_iva.replace(',', '.'),
                precio_litro_sin_iva: datosForm.precio_litro_sin_iva.replace(',', '.'),
                precio_kilo_con_iva: datosForm.precio_kilo_con_iva.replace(',', '.'),
                precio_kilo_sin_iva: datosForm.precio_kilo_sin_iva.replace(',', '.'),
                vigencia: moment(datosForm.vigencia).format("YYYY-MM-DD"),
                usuario: localStorage.getItem('user')
            },
            setNotificacion
        )
        logEventos(
            "Editar lista de precios",
            "LISTA DE PRECIOS GRANEL",
            "Actualiza lista de precios ",
            localStorage.getItem("user")
        );
    };

    const handleClose = () => {
        open(false);
        props.actualizar();
        props.tabla(true);
    };

    const formatoParaMostrar = (valor) => {
        if (valor === null || valor === undefined) return '';
        // Si es número, lo paso a string con coma
        if (typeof valor === 'number') {
            return valor.toFixed(2).replace('.', ',');
        }
        // Si es string, reemplazo punto por coma
        return valor.replace('.', ',');
    };

    const handleKeyDown = (e) => {
        // Permitir números y la coma
        if (!(
            (e.key >= '0' && e.key <= '9') ||
            e.key === ',' ||
            e.key === 'Backspace' ||  // permitir borrar
            e.key === 'ArrowLeft' ||   // permitir mover cursor
            e.key === 'ArrowRight' ||
            e.key === 'Tab'             // permitir tabular
        )) {
            e.preventDefault();
        }
    };

    return (
        <div>
            <Dialog open={open} fullWidth maxWidth="xl" onClose={handleClose}>
                {datosExisten && (
                    <Box sx={{ padding: 2 }}>
                        {/* Card para Precio Vigente */}
                        <Box backgroundColor={"#1F618D"}>
                            <DialogTitle>
                                <Typography variant="h6" align="center" color="#ffffff">
                                    Editar
                                    <br />
                                    Empresa:{datosExisten.empresa}  Sucursal:{datosExisten.sucursal}  Segmento:{datosExisten.segmento}  Producto: {datosExisten.nombre}

                                </Typography>
                            </DialogTitle>
                        </Box>
                        <Card variant="outlined" sx={{ mb: 1, backgroundColor: "#F4F6F6" }}>
                            <CardContent>

                                {/* Precios en un solo renglón */}
                                <Grid container spacing={1} alignItems="center" justifyContent="center">
                                    {[
                                        { label: "Precio litro sin IVA", value: datosForm.precio_litro_sin_iva || '', name: "precio_litro_sin_iva" },
                                        { label: "Precio litro con IVA", value: datosForm.precio_litro_con_iva || '', name: "precio_litro_con_iva" },
                                        { label: "Precio kilo sin IVA", value: datosForm.precio_kilo_sin_iva || '', name: "precio_kilo_sin_iva" },
                                        { label: "Precio kilo con IVA", value: datosForm.precio_kilo_con_iva || '', name: "precio_kilo_con_iva" },
                                    ].map((item, index) => (
                                        <Grid item xs={12} sm={6} md={2} key={index}>
                                            <TextField
                                                fullWidth
                                                style={style}
                                                focused
                                                size="small"
                                                variant="outlined"
                                                label={item.label}
                                                name={item.name}
                                                value={item.value}
                                                onChange={almacenar}
                                                onKeyDown={(e) => { handleKeyDown(e) }}
                                            />
                                        </Grid>
                                    ))}
                                    {/* Fechas de Vigencia */}
                                    <Grid item xs={12} sm={6} md={2}>
                                        <TextField
                                            fullWidth
                                            style={style}
                                            focused
                                            size="small"
                                            variant="outlined"
                                            label="Entrada en Vigencia"
                                            value={moment(datosForm.vigencia).format("DD-MM-YYYY") || ""}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    justifyContent="space-between"
                                    alignItems="flex-end"
                                    mt={2}
                                >
                                    <Button variant="contained"
                                        onClick={() => open(false)}
                                        color="error">
                                        Volver
                                    </Button>

                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color={"success"}
                                        onClick={putPrecios}
                                    >
                                        Actualizar
                                    </Button>
                                </Grid>
                            </CardContent>


                        </Card>
                        {notificacion && notificacion.open ? (
                            <Notify
                                mensaje={notificacion.mensaje}
                                open={notificacion.open}
                                color={notificacion.color}
                                handleClose={handleClose}
                                severity={notificacion.severity}
                            />
                        ) : null}
                    </Box>
                )}
            </Dialog>

        </div>
    )
}